/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgMagicFirewall = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.591 3.476 1.417.767-.394.691-1.375-.84.038 1.607h-.797l.038-1.607-1.374.84-.394-.691 1.416-.767-1.416-.767.394-.692 1.374.84-.038-1.607h.797l-.037 1.607 1.374-.84.393.691-.108.06-1.308.708Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m2 2.5-.5.5v10.5l.5.5h12l.5-.5V10l-.5-.5h-2.25v-3l-.5-.5H8.5V3L8 2.5H2Zm6.5 8h5V13h-5v-2.5Zm-1 0V13h-5v-2.5h5Zm-1.75-1V7h5v2.5h-5Zm-1 0V7H2.5v2.5h2.25ZM7.5 6h-5V3.5h5V6Z"
}));

export default SvgMagicFirewall;